import { Helmet } from 'react-helmet-async';

// 
// ─── COMPONENT DECLARATION ───────────────────────────────────────
//
const ViewContainer = ({ children, title }) => {
  // 
  // ─── COMPONENT RENDER ───────────────────────────────────────
  //
  return <>
    <Helmet title={title} />
    {children}
  </>
};

export default ViewContainer;